module.exports = __webpack_public_path__ + "img/5.5520fe26.png";